import { IUser } from '@gig/magic-sdk/dist/adapter/users/user';
import type { ILoyaltyTierConfig } from '@gig/magic-frontend-toolkit';
import { isBlackDiamondUser } from '../loyalty/loyalty.utils';

/**
 * Given the user's current loyalty level and the loyalty tiers configuration
 * the function returns the current loyalty tier for the logged in user.
 * Any unexpected conditions (missing config, wrong config ...) will default to 0.
 *
 * @param level current user's loyalty level
 * @param tiers loyalty tiers configuration
 *
 * @returns the current user loyalty tier
 */
export function calculateLoyaltyTier(
    level: number,
    tiers: ILoyaltyTierConfig[],
    user: IUser,
): number {
    const overrideTier = getOverrideTierValue(tiers, user);
    if (overrideTier !== undefined) {
        return overrideTier;
    }

    if (level < 0 || !tiers || tiers.length === 0) {
        return 0;
    }

    const tierIndex = tiers.findIndex(
        (curr) =>
            level >= curr.min && (curr.max === undefined || level <= curr.max),
    );
    return tierIndex > 0 ? tierIndex : 0;
}

/**
 * Encapsulate the slotbox specific logic for black diamond tier.
 * If the user has BlackDiamond or DC:ManagedVIP role, then the tier is set to tiers + 1
 * @param user the user object
 */
function getOverrideTierValue(tiersConfig: ILoyaltyTierConfig[], user: IUser): number | undefined {
    return isBlackDiamondUser(user) ? tiersConfig.length : undefined;
}
